import { render } from "./LogsResetPasswordMoodleUndbClassroom.vue?vue&type=template&id=1642d4a5"
import script from "./LogsResetPasswordMoodleUndbClassroom.vue?vue&type=script&lang=js"
export * from "./LogsResetPasswordMoodleUndbClassroom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__